// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ee3cba28","732":"a22dafc3","977":"fbef3082"}[chunkId] + ".chunk.js";
};